/**
 * iosReader — Helper per la conformità Apple App Store 3.1.1.
 *
 * iter v30 r145 — STRATEGIA AGGIORNATA: implementati Apple In-App Purchase
 * via RevenueCat. Su iOS native i CTA pricing NON sono più nascosti: ora
 * portano al paywall nativo Apple (`/dashboard/upgrade`).
 *
 * Su web tutto resta come prima (Stripe checkout).
 *
 * Riferimenti:
 *   - Apple Guidelines 3.1.1 (Payments — In-App Purchase)
 *   - Apple Small Business Program (15% commission)
 *   - RevenueCat Capacitor SDK (validazione ricevute + webhook)
 */

import { isNative } from "./native";

/** True quando l'app gira come iOS/Android Capacitor nativo. */
export const isReaderMode = isNative;

/**
 * Routing safe per i CTA "/pricing".
 *
 * - Su web → naviga a /pricing (Stripe)
 * - Su iOS native → naviga a /dashboard/upgrade (paywall IAP Apple)
 *
 * Usato dai vari bottoni "Passa a Pro" / "Sblocca" sparsi nel codebase.
 */
export function safePricingNavigate(navigate, fallback = "/dashboard/upgrade") {
  if (isNative) {
    navigate("/dashboard/upgrade");
    return true; // CTA eseguito (mostra paywall IAP)
  }
  navigate("/pricing");
  return true;
}

/**
 * Apre prontoimmo.it homepage in browser esterno (Safari) da iOS native.
 * Su web ricarica semplicemente la homepage.
 *
 * Usato per i link "Visita il sito" generici, NON per il checkout.
 */
export async function openWebForSignup() {
  const url = "https://prontoimmo.it";
  if (isNative) {
    try {
      const { Browser } = await import("@capacitor/browser");
      await Browser.open({ url });
      return;
    } catch {
      // Plugin assente o errore: fallback a window.open
    }
  }
  // Web o fallback: apri in nuova tab
  window.open(url, "_blank", "noopener,noreferrer");
}

/**
 * Testo standard per CTA "gestisci abbonamento" su iOS.
 * Su iPhone la gestione abbonamento avviene nelle Impostazioni iOS,
 * NON sul sito web (sennò Apple ci rifiuta per anti-steering).
 */
export const READER_MODE_NOTICE =
  "Gestisci il tuo abbonamento dalle Impostazioni iOS (Apple ID → Abbonamenti).";

